import React, { useReducer } from "react";
import ConfigContext from "../context/ConfigContext";
import ConfigReducer from "../reducer/ConfigReducer";

const initialConfig = {
  cashPickUpBanks: [],
  telcos: [],
  sourceOfIncome: [],
  purposeOfTransfer: [],
};

export const ConfigProvider = ({ children }) => {
  const [config, configDispatch] = useReducer(ConfigReducer, initialConfig);

  return (
    <ConfigContext.Provider value={{ config, configDispatch }}>
      {children}
    </ConfigContext.Provider>
  );
};
